import { Component, OnInit, ViewChild, Input, AfterViewInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { MatTable } from '@angular/material/table';
import { FIELDS } from 'src/app/shared/product/fields';
import { CustomValidators } from '../../../../../../../shared/custom-validators';
import { BaseForm } from '../../../../../../../shared/product/baseForm';
import { FormValidatorService } from '../../../../../../../shared/services/form-validator.service';
import { Validators } from '../../../../../../../shared/validators';
import { InvoiceStepFourComponent } from '../invoice-step-four/invoice-step-four.component';

@Component({
  selector: 'app-invoice-step-two',
  templateUrl: './invoice-step-two.component.html',
  styleUrls: ['./invoice-step-two.component.scss']
})
export class InvoiceStepTwoComponent extends BaseForm implements OnInit, AfterViewInit {
  isUpdate: any;
  id: any;
  @Input() productObject!: any;
  formValidator;
  stepForm!: FormGroup;
  productTypeId: any;
  itemArray: any[] = [];
  noItem: boolean = true;
  breaked: boolean = false;
  hasItem: boolean = false;
  total: number = 0;
  displayedColumns = ['Item Name', 'Quantity', 'Price', 'Actions'];
  propertiesColumns = ['Item Name', 'Quantity', 'Price'];
  @ViewChild(MatTable) table!: MatTable<any>;
  InvoiceItemsForm!: FormGroup;
  @ViewChild(InvoiceStepFourComponent) invoiceStepFour!: InvoiceStepFourComponent;

  itemController = {
    "Item Name":
    {
      'fieldName': 'Item Name',
      'fieldNameAr': 'إسم العنصر',
      'fieldType': 'Item Name',
      'isStaticUI': true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: CustomValidators.notInPattern(/^[0-9]*$/),
          message: `${this.validationMsg.notInPattern}`,
          messageAr: `${this.validationMsgAr.notInPattern}`
        },
        {
          validatorFn: Validators.minLength(2),
          message: `${this.validationMsg.minLength}2 characters`,
          messageAr: `${this.validationMsgAr.minLength}حرفان`
        }
      ]

    },
    "Price":
    {
      'fieldName': 'Price',
      'fieldNameAr': 'السعر',
      'fieldType': 'Price',
      'isStaticUI': true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: Validators.min(1),
          message: `${this.validationMsg.min}1`,
          messageAr: `${this.validationMsgAr.min}1`
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        },
      ]
    },
    "Quantity":
    {
      'fieldName': 'Quantity',
      'fieldNameAr': 'الكمية',
      'fieldType': 'Quantity',
      'isStaticUI': true,
      defaultValue: '',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: Validators.min(1),
          message: `${this.validationMsg.min}1`,
          messageAr: `${this.validationMsgAr.min}1`
        },
        {
          validatorFn: CustomValidators.customPattern(/^[0-9]*$/),
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        },
      ]
    },
  };

  controllers: any = {
    "is_buyer_info":
    {
      'fieldName': 'Do you want to Add extra Buyer info fields to your product?',
      'fieldNameAr': 'هل تريد ان تأخذ معلومات اضافية من المشتري؟',
      'fieldType': 'Do you want to Add extra Buyer info fields to your product?',
      'isStaticUI': true,
      defaultValue: '',
      validators: []
    },
    "Invoice Items":
    {
      'fieldName': 'Invoice Items',
      'fieldNameAr': 'عناصر الفاتورة',
      'fieldType': 'Invoice Items',
      'isStaticUI': true,
      defaultValue: '',
      validators: []
    },

  }
  constructor(private fb: FormBuilder) {
    super();
    this.formValidator = new FormValidatorService();
  }

  ngOnInit() {
    this.InvoiceItemsForm = this.fb.group({
      Invoice_Items: this.fb.array([])
    });
    this.addInvoiceItems();
    this.InvoiceItemsForm.valueChanges.subscribe(items => {
      this.updateStepTwoForm()
    })
    this.stepForm = this.formValidator.createForm(Object.values(this.controllers));
    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();
  }

  ngAfterViewInit() {
    if (this.productObject) {
      const invoice_items = this.productObject.invoice_items || [];
      for (const item of invoice_items) {
        this.addItem(item);
      }
    }
  }

  updateStepTwoForm() {
    this.noItem = false;
    this.stepForm.controls['Invoice Items'].setValue([]);
    this.total = 0;
    for (let item of this.InvoiceItems.controls) {
      if (item.valid) {
        this.stepForm.controls['Invoice Items'].setValue([...this.stepForm.controls['Invoice Items'].value, item.value]);
        this.total += (+item.value.Price * +item.value.Quantity);
        if (this.noItem != true)
          this.noItem = false;
      } else {
        this.noItem = true;
      }
    }
  }

  get InvoiceItems() {
    return this.InvoiceItemsForm.get('Invoice_Items') as FormArray;
  }

  removeItems(i: number) {
    this.InvoiceItems.removeAt(i);
  }

  addInvoiceItems() {
    if (this.InvoiceItems.valid) {
      this.InvoiceItems.push(this.formValidator.createForm(Object.values(this.itemController)));
    }
  }

  async addItem(object?: any) {
    if (object) {
      this.addInvoiceItems();
      this.InvoiceItems.controls[this.InvoiceItems.controls.length - 1].setValue({
        "Item Name": object.name,
        "Price": +object.price,
        "Quantity": +object.quantity,
      })
    }
    else if (this.stepForm.valid) {
      const formFields = Object.keys(this.stepForm.value);
      this.breaked = false;
      for (const field of formFields) {
        const resultField = this.controllers[field];
        if (resultField && resultField.fieldType === 'Item Name') {
          const result = this.itemArray.find(x => x[field] === this.stepForm.value[field]);
          if (result) {
            this.formValidator.addError(field, 'invalid', 'Item name already exists');
            this.stepForm.controls[field].setErrors({ 'invalid': 'invalid' });
            this.breaked = true;
            break;
          }
        }
      }
      if (this.breaked) {
        this.formValidator.forceShowErrors();
        return;
      } else {
        this.itemArray.push({
          "Item Name": this.stepForm.controls['Item Name'].value,
          "Price": this.stepForm.controls['Price'].value,
          "Quantity": this.stepForm.controls['Quantity'].value,
        });
      }
      this.clearItemForm();
      this.stepForm.markAsUntouched();
      if (this.itemArray[0]) {
        this.noItem = false;
        this.stepForm.controls['Invoice Items'].setValue(this.itemArray);
        this.setHasItem(true);

      } else {
        this.noItem = true;
        this.stepForm.controls['Invoice Items'].setValue(null);
        this.setHasItem(false);
      }
      this.table.renderRows();
    }
    else {
      this.formValidator.forceShowErrors();
    }
  }

  async deleteItem(object: any) {
    this.itemArray = await this.itemArray.filter(element => {
      return element !== object;
    });
    if (this.itemArray[0]) {
      this.noItem = false;
      this.stepForm.controls['Invoice Items'].setValue(this.itemArray);
      this.setHasItem(true);
    } else {
      this.noItem = true;
      this.stepForm.controls['Invoice Items'].setValue(null);
      this.setHasItem(false);

    }
    this.table.renderRows();
  }

  setHasItem(hasItem: any) {
    this.hasItem = hasItem;
  }

  clearItemForm() {
    this.stepForm.controls['Item Name'].setValue(null);
    this.stepForm.controls['Price'].setValue(null);
    this.stepForm.controls['Quantity'].setValue(null);
    this.stepForm.controls['Item Name'].setErrors(null);
    this.stepForm.controls['Price'].setErrors(null);
    this.stepForm.controls['Quantity'].setErrors(null);
  }

  convertInvoiceItemsControls(index: number, name: string) {
    return this.InvoiceItems.controls[index].get(name) as FormControl;
  }

  convertStepFormControls(name: string) {
    return this.stepForm.get(name) as FormControl;
  }
}
